import Vue from "vue";
import Vuelidate from "vuelidate";
import "./public-path";

// @ts-ignore
Vue.use(Vuelidate);
Vue.config.productionTip = false;

const asyncWidgets: Record<string, any> = {
  "app-quotes-wide": () => import("./Quotes/QuotesWide.vue"),
  sitemap: () => import("./Sitemap/index.vue"),
  "country-switcher-dev-form": () =>
    import("../forms/CountrySwitcherDevForm/index.vue")
};

const components: Record<string, any> = {};

Object.keys(asyncWidgets).forEach(name => {
  [...document.getElementsByTagName(name)].forEach(el => {
    asyncWidgets[name]().then((component: any) => {
      new Vue({
        el,
        components: {
          [name]: component.default,
          ...components
        }
      });
    });
  });
});
